// import axios from 'axios';

// export const nodeRestApi = axios.create({
//   //! remove this comment before git commit
//   // baseURL: 'https://api.ecozen.ai/dashboard/v1'
//   // baseURL: 'http://localhost:3000/dashboard/v1'
//   // baseURL: 'https://apis.ecozen.ai/dashboard/v3'
//   baseURL: 'http://localhost:4034/dashboard/v3'
// });

// export const loginApi = axios.create({
//   baseURL: 'https://api.ecozen.ai/dashboard/v1'
// });

import axios from 'axios';

export const nodeRestApi = axios.create({
  baseURL: 'https://apis.ecozen.ai/dashboard/v3'
});

let authToken = null;

export function setToken(token) {
  authToken = token;
}

export function clearToken() {
  authToken = null;
}

nodeRestApi.interceptors.request.use(config => {
  if (authToken && !config.url.includes('user/login')) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

nodeRestApi.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 403) {
      clearToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const loginApi = axios.create({
  baseURL: 'https://api.ecozen.ai/dashboard/v1'
});
